/* istanbul ignore file */
import React from 'react';
import { useFilterContext } from './FilterContext';
import InCondition from './condition/InCondition';
import { ConditionProps } from './condition/Condition';

const MultiSelectInputFilter = ({ children, ...props }: ConditionProps) => {
  const { filterBy } = useFilterContext();

  return (
    <InCondition {...props} onChangeCallback={filterBy}>
      {React.cloneElement(children, {
        menuPortalTarget: null,
      })}
    </InCondition>
  );
};

export default MultiSelectInputFilter;
